import type { Plugin } from "svelte-exmarkdown";
import { visit } from "unist-util-visit";

/**
 * Add a `lang` property to <pre> elements based on their <code> child class.
 */
export const rehypeAddPreLang: Plugin = {
  rehypePlugin: () => (tree) => {
    visit(tree, "element", (node) => {
      if (node.tagName === "pre") {
        const code = node.children.find(
          (child: any) => child.type === "element" && child.tagName === "code",
        );

        if (code) {
          const className = code.properties?.className || [];
          const langClass = className.find((cls: string) =>
            cls.startsWith("language-"),
          );

          if (langClass) {
            const lang = langClass.replace("language-", "");
            node.properties = {
              ...node.properties,
              lang,
            };
          }
        }
      }
    });
  },
};
